import React, { FC } from 'react';

// Components
import { StatisticComparisonRow } from './StatisticComparisonRow/StatisticComparisonRow';

// Constants
import { NEGATIVE_STATS } from '../../../../../../packages/constants/h2hStatistics';

// Types
import { INormalizeComparisonStatistics } from '../../../types';

interface Props {
  data: INormalizeComparisonStatistics[];
}

export const ComparisonStatisticsRowList: FC<Props> = ({ data }) => {
  if (!data || data?.length === 0) return null;

  return (
    <div className='statistics-comparison-container mt-6'>
      {data.map((row, index) => (
        <StatisticComparisonRow key={index} {...row} takeLowerValue={NEGATIVE_STATS.includes(row.name)} />
      ))}
    </div>
  );
};
